import { all } from 'redux-saga/effects'

import {
  watchCreateCityPlan,
  watchEditCityPlan,
  watchDeleteCityPlanById,
  watchGetCityPlanById,
  watchGetCityPlansByCampaignIdForFlyerCodesForm,
  watchGetCampaigns,
  watchGetCampaignsByClientId,
  watchUploadConversionReport,
  watchAddConversionReport,
} from 'Reducers/Campaigns/sagas'
import {
  watchCreateClient,
  watchGetClientById,
  watchGetClients,
  watchUpdateClientById,
} from 'Reducers/Clients/sagas'
// TODO: Commenting out the chat feature because it's causing my unit tests
// to fall over due to something obscure, at the time of writing the chat
// feature doesn't work anyway
/*import {
  watchPingServer,
  watchFetchContacts,
  watchSendMessage,
  watchUpdateMessageStatus,
  watchListenMyDialogs,
  watchSetActiveDialog,
  watchCreateChannel,
  watchAddChannelMembers,
  watchCreateDialog,
  watchRemoveDialog,
} from 'Reducers/Chat/sagas'*/
import {
  watchLoginUser,
  watchLoginUserOAuth2,
  watchLogoutUser,
  watchUserRequestResetPassword,
  watchCheckCodeAndHash,
  watchUserResetPassword,
} from './Auth/sagas'
import {
  watchGetCityPickupTime,
  watchCreateCityPickupTime,
  watchGetCities,
} from './City/sagas'
import {
  watchGetAmbassadorsByCityId,
  watchGetAmbassadorById,
  watchuploadAmbassadorDocument,
  watchUpdateAmbassadorById,
  watchUpdateAmbassadorByIdGpaphQL,
  watchGetAmbassadorDocumentsById,
  watchCreateAmbassadorDocumentsById,
  watchGetAmbassadorActivitiesById,
  watchSetAmbassadorStatus,
} from 'Reducers/Ambassador/sagas'
import {
  watchGetCampaignMissions,
  watchGetMisssionsByCityId,
  watchGetMissionById,
  watchCreateMissionPickup,
  watchUpdateMissionsAll,
  watchFetchScheduledPickup,
} from 'Reducers/Mission/sagas'
import {
  watchArchiveLocation,
  watchCreateLocation,
  watchGetLocationsByCityId,
  watchGetLocationById,
  watchGetLocationTypes,
  watchUpdateLocationById,
} from 'Reducers/Location/sagas'
import {
  watchCreateRoster,
  watchUpdateRoster,
  watchDeleteRosterById,
  watchGetRosterById,
  watchGetRostersByCityId,
  watchUpdateRostersMission,
  watchGetClientRostersByCities,
} from 'Reducers/Roster/sagas'
import {
  watchAddInventoriesByCityIdAll,
  watchGetInventoryTypes,
  watchEditInventory,
  watchEditInventoryAll,
} from 'Reducers/Inventory/sagas'
import { watchGetCountries } from 'Reducers/Countries/sagas'
import {
  watchGetUsers,
  watchCreateUser,
  watchGetUserById,
  watchUpdateUserById,
} from 'Reducers/Users/sagas'
import {
  watchGetPickupTimes,
  watchSavePickupTimesList,
} from 'Reducers/PickupTimes/sagas'
import {
  watchCreateDocumentType,
  watchGetDocumentTypeById,
  watchGetDocumentTypes,
  watchUpdateDocumentTypeById,
  watchDeleteDocumentTypeById,
} from 'Reducers/Document/sagas'
import {
  watchUploadProfileImage,
  watchUploadClientImage,
  watchUploadPitchFile,
  watchUploadFile,
} from 'Reducers/Upload/sagas'
import { watchGetExportedXeros } from 'Reducers/Xero/sagas'
import { watchCreateJob } from 'Reducers/Jobs/sagas'
export function* rootSaga() {
  yield all([
    watchCreateCityPlan(),
    watchCreateClient(),
    watchEditCityPlan(),
    watchDeleteCityPlanById(),
    watchCreateLocation(),
    watchFetchScheduledPickup(),
    watchDeleteRosterById(),
    watchGetAmbassadorById(),
    watchuploadAmbassadorDocument(),
    watchUpdateAmbassadorById(),
    watchUpdateAmbassadorByIdGpaphQL(),
    watchGetAmbassadorDocumentsById(),
    watchCreateAmbassadorDocumentsById(),
    watchGetAmbassadorsByCityId(),
    watchGetAmbassadorActivitiesById(),
    watchSetAmbassadorStatus(),
    watchCreateMissionPickup(),
    watchGetMissionById(),
    watchUpdateMissionsAll(),
    watchGetCampaigns(),
    watchGetCampaignMissions(),
    watchGetMisssionsByCityId(),
    watchGetCampaignsByClientId(),
    watchGetCityPlanById(),
    watchGetCityPlansByCampaignIdForFlyerCodesForm(),
    watchGetClientById(),
    watchGetClients(),
    watchGetCityPickupTime(),
    watchCreateCityPickupTime(),
    watchGetCities(),
    watchArchiveLocation(),
    watchGetLocationById(),
    watchGetLocationsByCityId(),
    watchGetLocationTypes(),
    watchCreateRoster(),
    watchUpdateRoster(),
    watchGetRostersByCityId(),
    watchGetRosterById(),
    watchLoginUser(),
    watchLoginUserOAuth2(),
    watchLogoutUser(),
    watchUpdateClientById(),
    /*
    watchPingServer(),
    watchFetchContacts(),
    watchSendMessage(),
    watchUpdateMessageStatus(),
    watchListenMyDialogs(),
    watchSetActiveDialog(),
    watchCreateChannel(),
    watchAddChannelMembers(),
    watchCreateDialog(),
    watchRemoveDialog(),
    */
    watchUpdateLocationById(),
    watchUserRequestResetPassword(),
    watchCheckCodeAndHash(),
    watchAddInventoriesByCityIdAll(),
    watchGetInventoryTypes(),
    watchEditInventory(),
    watchEditInventoryAll(),
    watchGetCountries(),
    watchGetUsers(),
    watchGetUserById(),
    watchCreateUser(),
    watchUpdateUserById(),
    watchGetPickupTimes(),
    watchSavePickupTimesList(),
    watchCreateDocumentType(),
    watchGetDocumentTypeById(),
    watchGetDocumentTypes(),
    watchUpdateDocumentTypeById(),
    watchDeleteDocumentTypeById(),
    watchUploadProfileImage(),
    watchUploadClientImage(),
    watchUploadPitchFile(),
    watchUploadFile(),
    watchGetExportedXeros(),
    watchUploadConversionReport(),
    watchAddConversionReport(),
    watchUpdateRostersMission(),
    watchGetClientRostersByCities(),
    watchCreateJob(),
    watchUserResetPassword(),
  ])
}
